
const SELECTORS = {
    // lightbox: '.lightbox, .content a[href]'
    lightbox: '.content a[href]'
}

const CLASSES = {
    galleryItem: 'gallery-item',
    blockGalleryItem: 'blocks-gallery-item',
    lightbox: 'lightbox'
}

export default class Lightbox {
    constructor () {
        this.isLoaded = false
    }

    initialize () {
        // const t = this

        // window.addEventListener(
            // 'load',//'DOMContentLoaded',
            // () => {
                this.lightbox = Array.from( document.querySelectorAll(SELECTORS.lightbox) )

                if (this.lightbox.length) {
                    this.init()
                } else {
                    this.isInit()
                }
            // }
        // )
    }

    init () {
        const t = this
        var shouldInit = false

        this.lightbox.forEach(elem => {
            var parent = elem.parentNode

            if (
                typeof elem.getAttribute('href') !== 'undefined'
                && elem.getAttribute('href').match(/\.(jpg|png|gif)/g)
                && !Util.hasClass( parent, CLASSES.galleryItem )
                && !Util.hasClass( parent.parentNode, CLASSES.galleryItem )
                && !Util.hasClass( parent, CLASSES.blockGalleryItem )
                && !Util.hasClass( parent.parentNode, CLASSES.blockGalleryItem )
            ) {
                shouldInit = true
                Util.addClass( elem, CLASSES.lightbox )

                const child = elem.querySelector('img')

                if ( Util.hasClass(child, 'alignleft')) {
                    Util.addClass(elem, 'alignleft')
                    Util.removeClass(child, 'alignleft')
                }
                if ( Util.hasClass(child, 'alignright')) {
                    Util.addClass(elem, 'alignright')
                    Util.removeClass(elem, 'alignright')
                }
                if ( Util.hasClass(child, 'alignnone')) {
                    Util.addClass(elem, 'alignnone')
                    Util.removeClass(child, 'alignnone')
                }
                if ( Util.hasClass(child, 'aligncenter')) {
                    Util.addClass(elem, 'aligncenter')
                    Util.removeClass(child, 'aligncenter')
                }

                // If low connection, load low quality image
                if (typeof App.isConnectionLow != 'undefined' && App.isConnectionLow ) {
                    let src = elem.getAttribute('href'),
                        ext = src.split('.').pop()
                    src = Util.splice(src, src.indexOf('.' + ext), 0, '--low')
                    elem.setAttribute('href', src)
                }
            }
        })

        if ( shouldInit ) {
            import('@js/vendor/lightense').then(function (module) {
                t.Lightense = module.default
                t.light = t.Lightense('.' + CLASSES.lightbox, {
                    App: App
                })
            })
        }

        this.isInit()
    }

    isInit () {
        this.isLoaded = true
        App.loadProgress += 1
        App.checkAppLoaded()
    }
}
